import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { MixpanelService } from '@services/mixpanel.service';
import { ResizeService } from '@services/resize.service';
import { FunctionsHelper } from '@shared/utils/helpers/functions.helper';
import { RegistrationStringResource } from '@shared/utils/helpers/registration-string.helper';
import { RegistrationHelper } from '@shared/utils/helpers/registration.helper';
import { SetAddSecondSleeper } from '@store/setup/setup.actions';
import { SetupSelectors } from '@store/setup/setup.selectors';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-setup-partner',
  templateUrl: './setup-partner.component.html'
})
export class SetupPartnerComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('container') container: ElementRef = new ElementRef('');
  bannerWidth = '';
  showBanner = false;
  isMobile = false;
  sleeperIntroduction = RegistrationStringResource.setupSleeperIntroduction(true);
  bannerData = RegistrationStringResource.bannerData;

  private _unsubscribeAll = new Subject<void>();

  constructor(private store: Store, private resizeService: ResizeService, private mixpanelService: MixpanelService) { }

  ngOnInit(): void {
    FunctionsHelper.scrollToTop();
  }

  ngAfterViewInit(): void {
    this.resizeService.isMobile.pipe(
      takeUntil(this._unsubscribeAll)
    ).subscribe((res) => {
      this.isMobile = res.isMobile;
      this.bannerWidth = `${this.container.nativeElement.offsetWidth}px`;
    });
  }

  skip(): void {
    this.mixpanelService.trackProceedSkipAction('set up sleep partner', RegistrationHelper.getProceedSkipActionFlow());
    this.store.dispatch(new SetAddSecondSleeper(null));
    RegistrationHelper.redirectToTheNextStep(this.store, this.store.selectSnapshot(SetupSelectors.shouldAddSecondSleeper));
  }

  changeBannerState(bannerState: boolean): void {
    this.showBanner = bannerState;
    if (this.showBanner)
      this.mixpanelService.trackBannerDisplay('set up sleep partner', this.bannerData);
  }

  next(): void {
    this.mixpanelService.trackProceedNextAction('set up sleep partner');
    this.store.dispatch(new SetAddSecondSleeper(null));
    this.store.dispatch(new Navigate(['pages/setup/create-login']));
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
